import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { useCart } from '../contexts/CartContext';
import { toast } from 'sonner';
import api from '../utils/api';
import { WhatsAppOrderButton } from './WhatsAppOrderButton';

const PLACEHOLDER = 'https://images.pexels.com/photos/5702290/pexels-photo-5702290.jpeg?w=400';

export const RelatedProducts = ({ productId, limit = 4 }) => {
  const [items, setItems] = useState([]);
  const { addToCart } = useCart();

  useEffect(() => {
    if (!productId) return;
    api
      .get(`/products/${productId}/related?limit=${limit}`)
      .then((res) => setItems(res.data || []))
      .catch(() => setItems([]));
  }, [productId, limit]);

  if (!items || items.length === 0) return null;

  return (
    <section data-testid="related-products" className="mt-16">
      <div className="flex items-end justify-between mb-6">
        <div>
          <p className="uppercase tracking-widest text-xs text-orange-600 font-semibold mb-1">
            Discover more
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-orange-900">
            You May Also Like
          </h2>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {items.map((p) => (
          <Card key={p.id} data-testid={`related-product-${p.id}`} className="group overflow-hidden">
            <Link to={`/product/${p.id}`}>
              <div className="aspect-square overflow-hidden bg-orange-50">
                <img
                  src={p.images?.[0] || p.image_url || PLACEHOLDER}
                  alt={p.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition"
                />
              </div>
            </Link>
            <CardContent className="p-3 md:p-4">
              <p className="text-xs text-orange-600 mb-1 line-clamp-1">{p.category_name}</p>
              <Link to={`/product/${p.id}`}>
                <h3 className="font-medium text-gray-800 hover:text-orange-600 line-clamp-2 text-sm">
                  {p.name}
                </h3>
              </Link>
              <div className="flex items-center justify-between mt-3">
                <span className="text-base md:text-lg font-bold text-orange-600">
                  ₹{p.sale_price || p.price}
                </span>
                <div className="flex gap-1">
                  <WhatsAppOrderButton product={p} compact className="w-8 h-8" />
                  <Button
                    size="sm"
                    onClick={() => {
                      addToCart(p);
                      toast.success('Added!');
                    }}
                    className="bg-orange-600 hover:bg-orange-700 h-8 w-8 p-0"
                    aria-label="Add to cart"
                  >
                    <ShoppingCart size={14} />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};
